import './header.js'
import './mobile.js'
import Url from 'url-parse'
import { loadScript } from './helpers.js'

//main script id store
const mainScript = document.getElementById( 'mainscript' )
window.assetsVersion =  mainScript ? ( Url( mainScript.src ).query || '' ) : ''

//delayed scripts
setTimeout( () => {
  //common scripts
  loadScript( '/js/app-delayed.js' )

}, process.env.MIX_LIB_3RD_DELAY )
